import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  VisuallyHidden,
} from "web-design-system";
import { AllocationBucket } from "creso-core/types";
import { AssetAllocationComparison } from "../asset-allocation-comparison";

export function AssetAllocationDialog({
  before,
  after,
  open,
  onOpenChange,
}: {
  before: AllocationBucket[];
  after: AllocationBucket[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-h-[90vh] max-w-5xl flex-col gap-6 overflow-y-auto">
        <DialogHeader>
          <VisuallyHidden>
            <DialogTitle>Asset allocation</DialogTitle>
          </VisuallyHidden>
          <span className="text-lg font-semibold">Asset allocation</span>
          <DialogDescription className="sr-only">
            Asset allocation of the current portfolio and after the review.
          </DialogDescription>
        </DialogHeader>
        <AssetAllocationComparison before={before} after={after} />
      </DialogContent>
    </Dialog>
  );
}
